module.exports = __webpack_public_path__ + "v4assets/network-explorer-screenshot-dark.330eb0781ce96d83a2b47000562519ef.png";